<script setup>
    import { ref, watchEffect } from 'vue';
    import axios from 'axios';

    const props = defineProps(['fetchUrl', 'addUrl', 'rechnungsempfaenger','antrag', 'antragState', 'contractStart', 'minDate', 'dateSelectorDisabled', 'nupsiId', 'tarifName', 'tarifNumber', 'lastName', 'firstName']);
    const teilnehmerInfo = ref(null);
    const submitError = ref(null);
    const submitResult = ref(null);
    const nupsiList = ref([]);
    const nupsiField = ref((props.nupsiId === "null" ? null : props.nupsiId));
    const teilnehmerCount = ref(1);

    watchEffect(async () => {
        teilnehmerInfo.value = await axios.get(props.fetchUrl);
        teilnehmerInfo.value = teilnehmerInfo.value.data.data;
        // if no Teilnehmer already exists, we get a null return.
        // In that case, we need to build our own teilnehmerInfo object,
        // containing anything we need for submission with props info.
        if (teilnehmerInfo.value === null) {
            teilnehmerInfo.value = {
                antrag: props.antrag,
                antragState: props.antragState,
                Rechnungsempfaenger: props.rechnungsempfaenger,
                Vertragsbeginn: props.contractStart,
                Tarifbezeichnung: props.tarifName,
                Tarifnummer: props.tarifNumber,
                Name: props.lastName,
                Vorname: props.firstName,
            };
        } else {
            // since fetchUrl just grabs the info from the latest Teilnehmer, that name might be irrelevant.
            // thus, we use the props, which get their names from the original Antrag.
            teilnehmerInfo.value.Name = props.lastName;
            teilnehmerInfo.value.Vorname = props.firstName;
        }
    });

    // saves a nupsi to the list, excluding duplicates or empty entries
    function saveNupsiToArray() {
        if (nupsiField.value === null) return;
        const nupsiAlreadyExists = (element) => element === nupsiField.value;
        if (nupsiList.value.findIndex(nupsiAlreadyExists) !== -1) return;
        nupsiList.value.push(nupsiField.value);
        nupsiField.value = null;
    }

    //disables Nupsi input field if no more Nupsis are needed
    function isAddNupsiDisabled() {
        if (nupsiList.value.length >= teilnehmerCount.value) {
            return true;
        }
        return false;
    }

    // disables Teilnehmer erstellen button if we don't have the exact needed number of Nupsis in
    function isSendDisabled() {
        if (nupsiList.value.length === teilnehmerCount.value) {
            return false;
        }
        return true;
    }

    // removes a Nupsi from the list
    function deleteListItem(nupsi) {
        const index = nupsiList.value.indexOf(nupsi);
        nupsiList.value.splice(index, 1);
    }

    // sends teilnehmerInfo and the Nupsi list to the backend
    async function submit() {
        submitError.value = null;
        submitResult.value = null;
        let res = {
            attendee: teilnehmerInfo.value,
            scannedRfids: nupsiList.value
        };
        await axios.post(props.addUrl, res)
        .then(function (response) {
            submitResult.value = response;
        }).catch(function (error) {
            submitError.value = error;
        });
    }

</script>
<template>
    <p>Hier kommt das Modal für nen Teilnehmer in Kundenanträge hin.</p>
    <form @submit.prevent="submit" v-if="teilnehmerInfo !== null">

        <div class="form-group">
            <label for="vertragsbeginn">Vertragsbeginn</label>
            <input
                v-model="teilnehmerInfo.Vertragsbeginn"
                type="date"
                id="vertragsbeginn"
                name="vertragsbeginn"
                class="form-control"
                :min="props.minDate"
                :disabled="props.dateSelectorDisabled"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Vertragsbeginn !== 'undefined')">
                {{ submitError.response.data.Vertragsbeginn[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="rfid">Nachname oder Firmenname</label>
            <input
                v-model="teilnehmerInfo.Name"
                type="text"
                id="lastName"
                name="Name"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.Name !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Name !== 'undefined')">
                {{ submitError.response.data.Name[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="rfid">Vorname (wenn nicht Firma)</label>
            <input
                v-model="teilnehmerInfo.Vorname"
                type="text"
                id="firstName"
                name="Name"
                class="form-control"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Vorname !== 'undefined')">
                {{ submitError.response.data.Vorname[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="teilnehmerCount">Anzahl an neuen Teilnehmern (zwischen 1 und 250): </label><br>
            <input
                type="number"
                id="teilnehmerCount"
                class="form-control"
                min="1"
                max="250"
                v-model="teilnehmerCount"
            />
        </div>
        <br>
        <div class="form-group">
            <div class="input-group mb-3">
                <label for="rfid">Nupsi-Kartennummer(n):</label>
                <small><em>Bitte jede Nupsi-Nummer, eine pro Teilnehmer, nacheinander eintragen und entweder per Enter-Taste oder per Knopf rechts vom Eingabefeld bestätigen, bevor das nächste Nupsi eingetragen wird.</em></small>
                <input
                    id="rfid"
                    type="text"
                    class="form-control"
                    v-model="nupsiField"
                    @keyup.enter="saveNupsiToArray()"
                    :disabled="isAddNupsiDisabled()"
                />
                <button v-if="nupsiList.length < teilnehmerCount" class="btn btn-outline-primary" type="button" id="button-addNupsi" @click="saveNupsiToArray()">Nupsi eintragen</button>
                <button v-if="nupsiList.length >= teilnehmerCount" class="btn btn-outline-primary" type="button" id="button-addNupsi" @click="saveNupsiToArray()" disabled>Nupsi eintragen</button>
            </div>
        </div>

        <ul class="list-group" v-if="nupsiList.length > 0">
            <li class="list-group-item" v-for="nupsi in nupsiList">
                <div class="row">
                    <div class="w-75">
                        {{ nupsi }}
                    </div>
                    <div class="w-25">
                        <button
                            type="button"
                            class="btn btn-outline-primary"
                            @click="deleteListItem(nupsi)">
                            Nupsi enfernen
                        </button>
                    </div>
                </div>
            </li>
        </ul>

        <br>
        <button id="submit"
            type="button"
            class="btn btn-primary"
            @click="submit()"
            :disabled="isSendDisabled()"
        >
            Teilnehmer anlegen
        </button>
    </form>

</template>
